import { DELETE_COURSE } from "./types";
import CoursesApi from "../api/CoursesApi";

export const deleteCourse = course => async dispatch => {
  try {
    const { data } = await CoursesApi().deleteCourse(course);

    dispatch({
      type: DELETE_COURSE,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 403) {
      console.error("No tienes permisos para eliminar este curso");
    } else {
      console.error("Error al eliminar el curso", error);
    }
    throw error;
  }
};
